import { render, staticRenderFns } from "./BrandCleanPreCheck.vue?vue&type=template&id=5947e19c&scoped=true"
import script from "./BrandCleanPreCheck.vue?vue&type=script&lang=js"
export * from "./BrandCleanPreCheck.vue?vue&type=script&lang=js"
import style0 from "./BrandCleanPreCheck.vue?vue&type=style&index=0&id=5947e19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5947e19c",
  null
  
)

export default component.exports